// extracted by mini-css-extract-plugin
module.exports = {"Home":"Homepage_Home__1L3Yr","lander":"Homepage_lander__3PUg0","DisclamerFooter":"Homepage_DisclamerFooter__1rUEs","PanelFix":"Homepage_PanelFix__3-Zhd"};